import { Box } from '@mui/material'
import { useMemo, useRef } from 'react'
import { useActionLoading } from '../hooks/useActionLoading'
import type { MediaGridProps } from '../types'
import { Columns } from './Columns'
import {
  getFilterModel,
  getRowClassName,
  getTogglableColumns,
  initialState,
  localeText,
} from './config'
import { Loading } from './Loading'
import { noResultsOverlay, StyledDataGrid } from './StyledDatagrid'
import { handlePaginationModelChange, handleSortModelChange } from './utils'

export function Datagrid(props: MediaGridProps) {
  const { gridMode, mediaLoading, rows } = props.staleMedia
  const selectionModelRef = useRef(props.selectionModel)
  selectionModelRef.current = props.selectionModel

  const actionLoading = useActionLoading()
  const columns = useMemo(() => {
    return Columns(props.openModal, selectionModelRef)
  }, [])

  if (!gridMode) return <Loading />
  const isServer = gridMode === 'server'
  const filterModel = getFilterModel(isServer, props.searchText)

  return (
    <Box flexGrow={1} position='relative' minHeight={400}>
      <Box position='absolute' top={0} left={0} right={0} bottom={0}>
        <StyledDataGrid
          rows={rows.results}
          getRowId={(row) => row.mediaCode}
          rowCount={isServer ? rows.totalCount : undefined}
          columns={columns}
          columnHeaderHeight={36}
          initialState={initialState}
          loading={mediaLoading || actionLoading}
          filterMode={gridMode}
          sortingMode={gridMode}
          paginationMode={gridMode}
          pagination
          pageSizeOptions={[10, 25, 50, 100]}
          filterModel={filterModel}
          onSortModelChange={(model) => {
            props.setSelectionModel([])
            if (!isServer) return
            handleSortModelChange(model, props.setPaginationRequest)
          }}
          onPaginationModelChange={(model) => {
            props.setSelectionModel([])
            if (!isServer || mediaLoading) return
            handlePaginationModelChange(model, props.setPaginationRequest)
          }}
          rowSelectionModel={props.selectionModel}
          onRowSelectionModelChange={props.setSelectionModel}
          checkboxSelection
          checkboxSelectionVisibleOnly
          disableColumnFilter
          disableColumnPinning
          disableRowSelectionOnClick
          getRowClassName={getRowClassName}
          slots={{ noResultsOverlay }}
          slotProps={{
            columnsManagement: { getTogglableColumns },
            pagination: { disabled: mediaLoading },
          }}
          localeText={localeText}
        />
      </Box>
    </Box>
  )
}
